import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dialog__title"
}
const _hoisted_2 = {
  key: 1,
  class: "dialog__desc"
}
const _hoisted_3 = { class: "dialog__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTimes = _resolveComponent("IconTimes")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_focus = _resolveDirective("focus")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#visible-screen-40" }, [
    _createElementVNode("div", {
      class: "dialog__page-mask",
      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["stop"]))
    }, [
      _createElementVNode("section", {
        class: "modal",
        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn btn-tertiary btn-sm modal__btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["esc"]))
        }, [
          _createVNode(_component_IconBase, null, {
            default: _withCtx(() => [
              _createVNode(_component_IconTimes)
            ]),
            _: 1
          })
        ], 32)), [
          [_directive_focus],
          [_directive_ripple]
        ]),
        (_ctx.slots.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_1, [
              _renderSlot(_ctx.$slots, "title")
            ]))
          : _createCommentVNode("", true),
        (_ctx.slots.default)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["btn btn-m", `btn-${_ctx.yes.type}`]),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmDialog && _ctx.confirmDialog(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.yes.text), 1)
          ], 2)), [
            [_directive_ripple]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["btn btn-m", `btn-${_ctx.no.type}`]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.no.text), 1)
          ], 2)), [
            [_directive_ripple]
          ])
        ])
      ])
    ])
  ]))
}